export default store => {
  store.subscribe(mutation => {
    if (mutation.type === "geolocation/LOCATION_CHANGED") {
      store.dispatch("player/LOCATION_UPDATED", mutation.payload);
    }
  });
};



// WEBPACK FOOTER //
// ./src/store/plugins/location.js